import React, { useRef } from "react";
import status from "../../../asset/images/Statustick.svg";


function Confirmation({ onNewUpload, setActiveTab, confirmationData }) {

    const {
        submittedCount = 0,
        // submittedNames = [],
        draftCount = 0,
        // draftNames = [],
        generatedSrIds = [],
    } = confirmationData || {};

    return (
        <div className="step-content">
            <div className="upload-box">
                <div className="wrap-content-upload">
                    <span className="upload-text">Confirmation</span>

                    <div className="conf-content">

                        <div className="upload-area">
                            <img src={status} alt="status icon" />

                            <div className="wrap-input-cont">
                                <span className="drag-text">Submission Successful!</span>

                                <div className="wrap-upload-info">
                                    {submittedCount > 0 && (
                                    <>
                                    <span className="upload-info">
                                        <span className="bold-text">{submittedCount} client{submittedCount > 1 ? "'s" : ""}</span>
                                         {" "}have been submitted to the Checker queue. 
                                    </span>
                                    {draftCount > 0 &&(
                                        <span className="upload-info">
                                        <span className="bold-text">{draftCount} client{draftCount > 1 ? "'s": ""} </span> records have been saved as Draft — upload supporting document to complete submission.
                                    </span>
                                    )}
                                    
                                    </>
                                    )}
                                </div>

                                <div className="info-banner width-banner">
                                    <span>Service Request IDs:</span>
                                    <span className="ids">
                                        {generatedSrIds.join(", ")}
                                    </span>
                                </div>

                                <div className="footer-actions conf-footer">
                                    <button className="back-btn" onClick={() => setActiveTab("srRequest")}>VIEW SERVICE REQUESTS</button>
                                    <button className="submit-btns" onClick={onNewUpload}>
                                        NEW UPLOAD
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>

        </div>
    );
}

export default Confirmation;